import { TranslateService } from '@ngx-translate/core';
import { toast } from 'ngx-sonner';

type ErrorToastDetailKey =
  | 'task-detail.scene-creation-failed'
  | 'task-detail.invalid-thumbnail'
  | 'task-detail.invalid-thumbnail-url';

type WarnToastSummaryKey = 'task-detail.scene-updated-partially';

type WarnToastDetailKey = 'task-detail.scene-updated-partially-detail';

function showErrorToast(translate: TranslateService, detailKey: ErrorToastDetailKey): void {
  toast.error(translate.instant(detailKey), { duration: 5000 });
}

function showWarnToast(
  translate: TranslateService,
  summaryKey: WarnToastSummaryKey,
  detailKey: WarnToastDetailKey
): void {
  toast.warning(translate.instant(summaryKey), {
    description: translate.instant(detailKey),
    duration: 5000,
  });
}

export function showSceneCreationFailedToast(translate: TranslateService): void {
  showErrorToast(translate, 'task-detail.scene-creation-failed');
}

export function showInvalidThumbnailToast(translate: TranslateService): void {
  showErrorToast(translate, 'task-detail.invalid-thumbnail');
}

export function showInvalidThumbnailUrlToast(translate: TranslateService): void {
  showErrorToast(translate, 'task-detail.invalid-thumbnail-url');
}

export function showSceneUpdatedPartiallyToast(translate: TranslateService): void {
  showWarnToast(
    translate,
    'task-detail.scene-updated-partially',
    'task-detail.scene-updated-partially-detail'
  );
}
